export const SEARCH_DELAY = 500;

export const TYPE_OPTIONS = [
  { value: 'profile', label: 'Profile' },
  { value: 'waitlist', label: 'Waitlist' },
  { value: 'other', label: 'Other' },
];
